/*
 * @Descripttion:
 * @version:
 * @Author: ouli
 * @Date: 2021-10-27 18:04:22
 * @LastEditors: ouli
 * @LastEditTime: 2021-11-02 18:14:16
 */
// 跨域代理前缀
// const API_PROXY_PREFIX='/api';'http://sit.scm.linshimuye.com:82'http://dev.scm.linshimuye.com:182
// const API_PROXY_SSO_PREFIX='/ssoapi';
/* const BASE_URL =  process.env.NODE_ENV === 'development' ?  'http://dev.scm.linshimuye.com:182' : process.env.VUE_APP_API_BASE_URL;
// const OASSO_URL=process.env.VUE_APP_API_OASSO_URL;
const OFFICEONLINE = process.env.VUE_APP_API_OFFICEONLINE;
// const BASE_URL = process.env.VUE_APP_API_BASE_URL
console.log(BASE_URL)
module.exports = {
  BASE_URL,
  OASSO_URL,
  OFFICEONLINE
} */

// 跨域代理前缀
const API_PROXY_PREFIX = '/api';
const API_PROXY_SSO_PREFIX = '/ssoapi';
const API_PROXY_PLMOSS_PREFIX = '/plmoss';
const BASE_URL = process.env.NODE_ENV === 'development' ? API_PROXY_PREFIX : process.env.VUE_APP_API_BASE_URL;
const SSO_URL = process.env.NODE_ENV === 'development' ? API_PROXY_SSO_PREFIX : process.env.VUE_APP_API_SSO_URL;
const PLM_OSS = process.env.NODE_ENV === 'development' ? API_PROXY_PLMOSS_PREFIX : process.env.VUE_APP_API_PLMOSS_URL;
const FADADA_URL = process.env.VUE_APP_API_FADADA_URL
const AI_URL = process.env.VUE_APP_API_AI_URL
// const OASSO_URL=process.env.VUE_APP_API_OASSO_URL;
// const BASE_URL = process.env.VUE_APP_API_BASE_URL
module.exports = {
  API_PROXY_PREFIX,
  BASE_URL,
  SSO_URL,
  // OASSO_URL,
  PLM_OSS,
  FADADA_URL,
  AI_URL
}
